import React from 'react';
import UserAvatar from '../../dumpComponent/userAvatar';

const ViewerAvatar = (props) => {
    const { className, brandingHilightColor, sender } = props;
    const userName = (sender && sender.name) || '';
    const userAvartar = (sender && sender.avatar) || '';

    return (<UserAvatar
        className={className}
        userName={userName}
        hilightColor={brandingHilightColor}
        userAvartar={userAvartar} />);
};

export default ViewerAvatar;
